import { render, staticRenderFns } from "./MaterialsImportList.vue?vue&type=template&id=23047fd0&scoped=true"
import script from "./MaterialsImportList.vue?vue&type=script&lang=js"
export * from "./MaterialsImportList.vue?vue&type=script&lang=js"
import style0 from "./MaterialsImportList.vue?vue&type=style&index=0&id=23047fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23047fd0",
  null
  
)

export default component.exports